import DateFnsUtils from "@date-io/date-fns";

// DateFnsUtils implemented with class syntax. MaterialUI doesn't allow usage of arrow syntax
export class LocalizedUtils extends DateFnsUtils {
    getCalendarHeaderText(date: Date) {
        return this.format(date, "MMMM yyyy").replace(/ta\b/, "");
    }
}
